import Vue from 'vue';
const isVue2 = Vue.version.split('.')[0] === '2';

const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const arabicNumbers = ['٠', '۱', '٢', '۳', '٤', '٥', '٦', '۷', '۸', '۹'];
const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const numberRange = [ ...persianNumbers, ...arabicNumbers, ...englishNumbers];

const VueNumber = function (Vue) {
    if (isVue2){
        Vue.directive('number', {
            update: function(el) {
                if (typeof el.value === 'undefined') return;
                let value = el.value.toString();
                let lastChar = value.substr(value.length - 1, value.length);
                let indexOfLastChar = numberRange.indexOf(lastChar);

                if (indexOfLastChar > -1) {
                    for (let j of englishNumbers) {
                        value = value.replace(new RegExp(persianNumbers[j], 'g'), englishNumbers[j]);
                        value = value.replace(new RegExp(arabicNumbers[j], 'g'), englishNumbers[j]);
                    }
                }
                else {
                    value = value.substr(0, value.length -1);
                }
                el.value = value;
                el.dispatchEvent(new Event('input'));
            }
        })
    }
};

export default VueNumber;